import { useQueryClient } from "@tanstack/react-query";

import {
  getGetScheduledNotificationsQueryKey,
  useCancelScheduledNotification as useCancelScheduledNotificationGenerated,
  useExpirePendingNotification as useExpirePendingNotificationGenerated,
} from "@/api/generated";

export const useCancelScheduledNotification = () => {
  const queryClient = useQueryClient();

  return useCancelScheduledNotificationGenerated({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getGetScheduledNotificationsQueryKey(),
        });
      },
    },
  });
};

export const useExpirePendingNotification = () => {
  const queryClient = useQueryClient();

  return useExpirePendingNotificationGenerated({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getGetScheduledNotificationsQueryKey(),
        });
      },
    },
  });
};
